import {LatLngTuple} from "leaflet";

export interface INotificacion {
    message: string
    variant: 'info' | 'warning' | 'error' | 'success'
}

export interface IPointCoords {
    lat: number
    lon: number
}

export interface IelTiempoData {
    temperatura: number,
    velocidadViento: number,
    humedad: number
    icono: string,
    descripcion: string,
    fecha: string
}

export interface IZona {
    id: string
    rangos: number[][],
    colores: string[],
    poligonos: {
        area: number,
        color: string,
        id: string,
        lat_lon_coords: LatLngTuple[]
    }[]
}

export interface IDataPartner {
    partner: Record<string, string|number>
    users: Record<string, string|number>[]
    plots: Record<string, Record<string, string|number>[]>
}

export interface IConnection {
    name: string
    basico: number
    avanzado: number
    profesional: number
    otro: number
}

export interface IConnections {
    mensual: IConnection[]
    semanal: IConnection[]
    diaria: IConnection[]
}

export type ISections = 'principal' | 'crear_parcela' | 'propiedades' | 'Gestión de usuarios' | 'visualizador' |
    'riego_neto' | 'subir_datos' | 'configuracion' | 'caracterizacion' | "estaciones"

export type IPartnersSections = 'dashboard' | 'clientes' | 'promociones' | 'opciones' | 'chat' | 'faq'

export type IMapas = 'satelite' | 'carreteras'

export type IParcela = Record<string, any>

export type INewParcelaSection = 'Caracterización' | 'Ubicación' | 'Sectores' | 'InfoFinal' | 'AyudaParcela' | 'AyudaSector'

export type IAvanzadoSections = "historico" | "automata" | "rpas" | "consola"

export type IFuente = "SENTINEL 2A"  | "LANDSAT 8" | "RPAS" | "UTW"

// export type ISistemasProduccion = null | "Tradicional"  | "Intensivo secano" | "Intensivo regadío" |
//     "Superintensivo secano" | "Superntensivo regadío"


export const sistemasProduccion = [
    "Tradicional",
    "Intensivo secano",
    "Intensivo regadío",
    "Superintensivo secano",
    "Superntensivo regadío"
]
export type ISistemasProduccion = typeof sistemasProduccion[number]

// cultivos leñosos y herbaceos
export const cultivos = [
    "aguacate",
    "ajo",
    "albaricoque",
    "almendro",
    "caqui",
    "cebada_invierno",
    "cebada_primavera",
    "cerezo",
    "citricos",
    "granado",
    "kiwi",
    "maiz",
    "manzano",
    "melocoton",
    "nogal",
    "olivar",
    "peral",
    "pistacho",
    "uva_de_mesa",
    "uva_de_vino"
]
export type ICultivos = typeof cultivos[number]

// solo cultivos leñosos
export const woody_crops = [
    "aguacate",
    "albaricoque",
    "almendro",
    "caqui",
    "cerezo",
    "citricos",
    "granado",
    "kiwi",
    "manzano",
    "melocoton",
    "nogal",
    "olivar",
    "peral",
    "pistacho",
    "uva_de_mesa",
    "uva_de_vino"
]
export type Iwoody_crops = typeof cultivos[number]


export const texturas = [
    "arenoso",
    "franco",
    "arcilloso"
]
export type ITexturas = typeof texturas[number]
